import { getHslAnimationFromHsl, getRangeValue, itemFromSingleOrMultiple, rangeColorToHsl } from "tsparticles-engine";
import { updateStrokeColor } from "./Utils";
export class StrokeColorUpdater {
  constructor(container) {
    this.container = container;
  }
  init(particle) {
    var _stroke$opacity, _stroke$color, _rangeColorToHsl;
    const container = this.container,
      options = particle.options;
    const stroke = itemFromSingleOrMultiple(options.stroke, particle.id, options.reduceDuplicates);
    particle.strokeWidth = getRangeValue(stroke.width) * container.retina.pixelRatio;
    particle.strokeOpacity = getRangeValue((_stroke$opacity = stroke.opacity) !== null && _stroke$opacity !== void 0 ? _stroke$opacity : 1);
    particle.strokeAnimation = (_stroke$color = stroke.color) === null || _stroke$color === void 0 ? void 0 : _stroke$color.animation;
    const strokeHslColor = (_rangeColorToHsl = rangeColorToHsl(stroke.color)) !== null && _rangeColorToHsl !== void 0 ? _rangeColorToHsl : particle.getFillColor();
    if (strokeHslColor) {
      particle.strokeColor = getHslAnimationFromHsl(strokeHslColor, particle.strokeAnimation, container.retina.reduceFactor);
    }
  }
  isEnabled(particle) {
    const color = particle.strokeAnimation,
      {
        strokeColor
      } = particle;
    return !particle.destroyed && !particle.spawning && !!color && ((strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.h.value) !== undefined && strokeColor.h.enable || (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.s.value) !== undefined && strokeColor.s.enable || (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.l.value) !== undefined && strokeColor.l.enable);
  }
  update(particle, delta) {
    if (!this.isEnabled(particle)) {
      return;
    }
    updateStrokeColor(particle, delta);
  }
}